export default "__VITE_ASSET__BqyTuEly__"